import { DataV2API } from "../Endpoints";

class ExportPrices {
    getAll() {
        return DataV2API.get("/exports");
    }

    addTo(exportPrices) {
        return DataV2API.post("/exports", exportPrices);
    }

    sendCSVMailExport(save_id, email, emailText) {
        return DataV2API.post(`/export/${save_id}/csv/`, { email: email, description: emailText });
    }
    sendPDFMailExport(save_id, email, emailText, pharmacyId) {
        return DataV2API.post(`/export/${save_id}/pdf/${pharmacyId}`, {
            email: email,
            description: emailText
        });
    }
    getCSVDownloadExport(save_id) {
        DataV2API.download(`/export/${save_id}/csv/`, { download: true })
            .then(response => {
                this.downloadHelper(response, "text/csv");
            })
            .catch(console.error);
    }
    getPDFDownloadExport(save_id, pharmacyId) {
        DataV2API.download(`/export/${save_id}/pdf/${pharmacyId}`, { download: true })
            .then(response => {
                this.downloadHelper(response, "application/pdf");
            })
            .catch(console.error);
    }
    downloadHelper(response, type) {
        const blob = new Blob([response.data], { type: type });
        console.log(blob);
        console.log(URL.createObjectURL(blob));
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);

        let filename = undefined;
        try {
            filename = response.request
                .getResponseHeader("Content-Disposition")
                .replace(new RegExp("attachment; filename=", "gm"), "");
        } finally {
            if (!filename) {
                // fallback if CORS-Error or the header is missing
                filename = "Preisliste." + (type.match(/\/(.*)/)[1] || "txt");
            }
        }
        link.download = filename;
        link.click();
        URL.revokeObjectURL(link.href);
    }
    delete(save_id) {
        return DataV2API.delete("/export/" + save_id);
    }
}

export default new ExportPrices();
